import React, { Component } from 'react';
import { filter } from 'lodash';
import { Tree } from '@blueprintjs/core';
import Modal from 'react-bootstrap/lib/Modal';
import Button from 'react-bootstrap/lib/Button';
import { injectIntl, FormattedMessage } from 'react-intl';
import { recallColumns } from '../../../utils';

class SortModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      sort: props.sort
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.showModal) {
      this.setState({
        sort: nextProps.sort
      });
    }
  }

  applySort() {
    const { updateRecallsSortOpts, onClose } = this.props;
    updateRecallsSortOpts(this.state.sort, 'ASC');
    onClose();
  }

  render() {
    const { showModal, onClose, config } = this.props;
    const { formatMessage } = this.props.intl;
    const { sort } = this.state;

    const treeContents = filter(recallColumns(config), { sortable: true }).map(col => ({
      id: col.dataKey,
      label: formatMessage({ id: col.intl.title }),
      isSelected: col.dataKey === sort,
    }));

    return (
      <Modal show={showModal} onHide={onClose}>
        <Modal.Header closeButton>
          <Modal.Title>
            <FormattedMessage id="sort.modal.title"/>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: '0 15px' }}>
          <p className="m10-top">
            <strong>
              <FormattedMessage id="recalls.sort"/>:
            </strong>
          </p>
          <Tree
            contents={treeContents}
            onNodeClick={node => this.setState({ sort: node.id })}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={onClose}>
            <FormattedMessage id="common.close"/>
          </Button>
          <Button bsStyle="primary" onClick={() => this.applySort()}>
            <FormattedMessage id="common.applyChanges"/>
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default injectIntl(SortModal);



// WEBPACK FOOTER //
// ./src/views/recalls-list/side-bar/sort-modal.js